import React from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines, className = "", lineClassName = "" }) => (
  <motion.span
    className={className}
    initial="hidden"
    animate="show"
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.13, delayChildren: 0.15 } } }}
  >
    {lines.map((line, i) => (
      <span key={i} className="hero-mask-line">
        <motion.span
          className={`block ${lineClassName}`}
          variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Kicker = ({ children, light = false }) => (
  <p className={`eyebrow ${light ? "text-[#A9CFE2]" : "text-[#3E9BDC]"} flex items-center gap-3`}>
    <span className={`w-8 h-px ${light ? "bg-[#A9CFE2]" : "bg-[#3E9BDC]"}`} />
    {children}
  </p>
);
